import { cutOutFrame } from '../utils/cutOutFrame';
import { game } from 'js/main';

export function prepareFieldGfx(): void {
  const gameFieldPiece = cutOutFrame('ui', 'gamefield');
  const cutOutPiece = cutOutFrame('ui', 'field_cutout');

  const canvas = document.createElement('canvas');
  canvas.width = 538;
  canvas.height = 777;
  const ctx = canvas.getContext('2d')!;

  if (game.horizontal) {
    // @ts-ignore
    game.cache.addImage('gamefield_l', undefined, prepareField(gameFieldPiece, cutOutPiece, 895, 687, -3));
  } else {
    // @ts-ignore
    game.cache.addImage('gamefield_p', undefined, prepareField(gameFieldPiece, cutOutPiece, 538, 777, 0));
  }
}


function prepareField(fieldPiece: HTMLCanvasElement, cutOutPiece: HTMLCanvasElement, width: number, height: number, cutOutOffset: number): HTMLCanvasElement {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d')!;

  const topBar = prepareTop(fieldPiece, width);
  ctx.drawImage(topBar, 0, 0);

  fillY(
    topBar,
    canvas,
    new Phaser.Rectangle(0, topBar.height - 10, topBar.width, 10),
    new Phaser.Rectangle(0, topBar.height, topBar.width, height - topBar.height * 2)
  );

  ctx.scale(1, -1)
  ctx.drawImage(topBar, 0, -canvas.height);

  ctx.setTransform(1, 0, 0, 1, 0, 0);

  const cutOutX = Math.floor(width * 0.5 - cutOutPiece.width * 0.5) + cutOutOffset;
  const cutOutY = height - cutOutPiece.height;

  ctx.clearRect(cutOutX, cutOutY, cutOutPiece.width, cutOutPiece.height);
  ctx.drawImage(cutOutPiece, cutOutX, cutOutY);

  return canvas;
}

function prepareTop(fieldPiece: HTMLCanvasElement, width: number): HTMLCanvasElement {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height =  fieldPiece.height;
  const ctx = canvas.getContext('2d')!;

  ctx.drawImage(fieldPiece, 0, 0);

  ctx.scale(-1, 1);
  ctx.drawImage(fieldPiece, -canvas.width, 0);
  ctx.setTransform(1, 0, 0, 1, 0, 0);

  const toFill = width - fieldPiece.width * 2;
  fillX(
    fieldPiece,
    canvas,
    new Phaser.Rectangle(fieldPiece.width - 10, 0, 10, fieldPiece.height),
    new Phaser.Rectangle(fieldPiece.width, 0, toFill, fieldPiece.height),
  );

  return canvas;
}

function fillX(
  source: HTMLCanvasElement,
  target: HTMLCanvasElement,
  sliceToCopy: Phaser.Rectangle,
  areaToFill: Phaser.Rectangle,
): HTMLCanvasElement {
  const ctx = target.getContext('2d')!;

  while (areaToFill.width > 0) {
    const sliceWidth = Math.min(sliceToCopy.width, areaToFill.width);
    ctx.drawImage(
      source,
      sliceToCopy.x, sliceToCopy.y, sliceWidth, sliceToCopy.height,
      areaToFill.x, areaToFill.y, sliceWidth, areaToFill.height,
    );
    areaToFill.x += sliceWidth;
    areaToFill.width -= sliceWidth;
  }

  return target;
}

function fillY(
  source: HTMLCanvasElement,
  target: HTMLCanvasElement,
  sliceToCopy: Phaser.Rectangle,
  areaToFill: Phaser.Rectangle,
): HTMLCanvasElement {
  const ctx = target.getContext('2d')!;

  while (areaToFill.height > 0) {
    const sliceHeight = Math.min(sliceToCopy.height, areaToFill.height);
    ctx.drawImage(
      source,
      sliceToCopy.x, sliceToCopy.y, sliceToCopy.width, sliceHeight,
      areaToFill.x, areaToFill.y, areaToFill.width, sliceHeight,
    );
    areaToFill.y += sliceHeight;
    areaToFill.height -= sliceHeight;
  }

  return target;
}
